import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { MessagesService } from './messages.service';
import { NotificationService } from 'src/app/pages/Notification/notification.service';
import { Notification } from 'src/app/pages/Notification/notification.model';
import { Settings } from 'src/app/app.settings.model';
import { AppSettings } from 'src/app/app.settings';
import { TranslateService } from '@ngx-translate/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { AuthLayoutComponent } from 'src/app/shared-component/auth-layout/auth-layout.component';

@Component({
  selector: 'app-messages',
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [MessagesService],
  standalone: false
})
export class MessagesComponent implements OnInit {
  @ViewChild(MatMenuTrigger) trigger: MatMenuTrigger;
  public selectedTab: number = 1;

  public files: Array<Object>;
  public meetings: Array<Object>;

  public settings: Settings;
  notifications: Notification[] = [];
  currentDate;
  notificationsPageIndex: number = 0;
  notificationsTotalRows: number = 0;
  notificationsCount: number = 0;
  pageSize = 4;

  constructor(private messagesService: MessagesService,
    public appSettings: AppSettings,
    public notificationService: NotificationService,
    private authLayout: AuthLayoutComponent,
    private translate: TranslateService,
    private route: Router,
    private _snackBar: MatSnackBar) {
    this.settings = this.appSettings.settings;
    this.files = messagesService.getFiles();
    this.meetings = messagesService.getMeetings();
  }

  ngOnInit() {
    this.currentDate = new Date();
    this.getNotificationsCount();
  }

  getNotificationsCount() {
    this.notificationService.getNotificationsCount().subscribe(result => {
      this.notificationsCount = result;
    });
    this.getNotifications();
  }

  getNotifications() {
    this.notificationsPageIndex = 1;
    this.notificationService.getNotifications(this.notificationsPageIndex, this.pageSize).subscribe(result => {
      if (result != null) {
        this.notifications = result.list;
        this.notificationsTotalRows = result.totalRows;
      }
    });
  }

  dismissNotification(notification, event: MouseEvent) {
    event.stopPropagation(); // Prevent click event from reaching the parent button

    this.notificationService.dismissNotification(notification.id).subscribe(result => {
      if (result) {
        this._snackBar.open(this.translate.instant('Notification dismissed successfully'), null, {
          duration: 2000
        });
        this.getNotificationsCount();
      }
    });
  }

  markNotificationAsRead(notification) {
    this.notificationService.markNotificationAsRead(notification.id).subscribe(result => {
      if (result) {
        if (!notification.isRead)
          this._snackBar.open(this.translate.instant('Notification marked as read successfully'), null, {
            duration: 2000
          });
      }
      this.getNotificationsCount();
      this.authLayout.sidenav.open();
      location.href = notification.link;
    });
  }

  onScrollToBottom(): void {
    setTimeout(() => {
      let chatContainer = document.querySelector('.content');
      if (chatContainer) {
        const isAtBottom = chatContainer.scrollHeight - chatContainer.scrollTop <= chatContainer.clientHeight + 5;
        if (isAtBottom && this.notificationsTotalRows != this.notifications.length) {
          this.notificationsPageIndex += 1;
          this.notificationService.getNotifications(this.notificationsPageIndex, this.pageSize).subscribe(result => {
            this.notifications = [...this.notifications, ...result.list];
          });
        }
      }
    });
  }


  calculateTimeDifference(sentDateStr: string): string {
    const sentDate = this.convertUTCDateToLocalDate(new Date(sentDateStr));
    const currentDate = new Date();
    const timeDifference = currentDate.getTime() - sentDate.getTime();

    const minutes = Math.floor(timeDifference / (1000 * 60)) % 60;
    const hours = Math.floor(timeDifference / (1000 * 60 * 60)) % 24;
    const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));

    if (days > 0) {
      return `${days} ${days === 1 ? this.translate.instant('day') : this.translate.instant('days')}`;
    } else {
      return `${hours} ${this.translate.instant('hours')}, ${minutes} ${this.translate.instant('minutes')}`;
    }
  }

  convertUTCDateToLocalDate(date) {
    var utc = new Date(date);
    var offset = utc.getTimezoneOffset();
    var newDate = new Date(utc.getTime() - offset * 60000);
    return newDate;
  }

  onMessagesMenuOpened() {
    this.getNotificationsCount();
    this.getNotifications();
    this.selectedTab = 0;
  }

  onMouseLeave() {
    this.trigger.closeMenu();
  }

  stopClickPropagate(event: any) {
    event.stopPropagation();
    event.preventDefault();
  }

  trackById(index: number, item: any) {
    return item.id;
  }

  /** Shown on the bell badge (capped for layout). */
  get badgeCountLabel(): string {
    const n = this.notificationsCount;
    if (n > 99) {
      return '99+';
    }
    return String(n);
  }

}
